import { bosAtlasStore } from "../redux/Store"
import type { HttpMethod } from "../redux/http/http.types"
import { pushRequestSnackbar } from "../redux/snackbar/snackbar.actions"

export function dispatchSnackbar(subject: string, method: HttpMethod, success: boolean, customMessage?: string): void {
  bosAtlasStore.dispatch(pushRequestSnackbar(subject, method, success, customMessage))
}
